module.exports = __webpack_public_path__ + "static/media/141.797c8325.wav";